import { RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider as ReduxProvider } from 'react-redux'
import { Suspense } from 'react'
import { appRouter } from './routes/appRouter'
import { persistedStore, appStore } from './store/appStore'
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary/ErrorBoundary'
import { ThemeProvider } from '@/shared/theme/ThemeProvider'
import { Spin, Flex } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import './styles/index.css'

const loading = (
  <Flex
    style={{ width: '100vw', height: '100vh' }}
    align='center'
    justify='center'
    gap='middle'
  >
    <Spin size='large' indicator={<LoadingOutlined spin />} />
  </Flex>
)

export const App = () => {
  return (
    <PersistGate loading={loading} persistor={persistedStore}>
      <ErrorBoundary>
        <ReduxProvider store={appStore}>
          <ThemeProvider>
            <Suspense fallback={loading}>
              <RouterProvider router={appRouter()} />
            </Suspense>
          </ThemeProvider>
        </ReduxProvider>
      </ErrorBoundary>
    </PersistGate>
  )
}
